import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ModalComfirmImport.module.scss';
import { AiOutlineClose } from 'react-icons/ai';

const ModalComfirmImport = ({
  setModalConfirmImport,
  setOverlay,
  isCheckedDateUpdate,
  checkHandler,
  setMaj,
  maj,
  registerNewValue,
  setModalConfirmRegisterNewValue,
}) => {
  const { t } = useTranslation();
  const handleCancel = () => {
    setMaj(!maj);
    setOverlay(false);
    setModalConfirmImport(false);
    setModalConfirmRegisterNewValue(false);
  };

  return (
    <>
      <div className={styles.wrapperModal} onClick={handleCancel} />
      <div className={styles.containerModal}>
        <button className={`${styles.closeBtn} has-tooltip`} onClick={handleCancel} aria-label={t("common.close")}>
          <AiOutlineClose />
        </button>

        <h4 className={styles.modalTitle}>{t("calibration_data.imported_data")}</h4>

        <p className={styles.modalText}>
          {t("calibration_data.data_imported_text")}
        </p>

        <label className={styles.checkRow}>
          <input
            type="checkbox"
            checked={isCheckedDateUpdate}
            onChange={checkHandler}
          />
          {t("calibration_data.update_with_today")}
        </label>

        <div className={styles.actions}>
          <button className={styles.btnCancel} onClick={handleCancel}>{t("calibration_data.revert_to_previous")}</button>
          <button className={styles.btnConfirm} onClick={registerNewValue}>{t("common.save")}</button>
        </div>
      </div>
    </>
  );
};

export default ModalComfirmImport;